import { render, staticRenderFns } from "./tzgg.vue?vue&type=template&id=f964cc88&scoped=true"
import script from "./tzgg.vue?vue&type=script&lang=js"
export * from "./tzgg.vue?vue&type=script&lang=js"
import style0 from "./tzgg.vue?vue&type=style&index=0&id=f964cc88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f964cc88",
  null
  
)

export default component.exports